import RenderTooltipTitles from './RenderTooltipTitles';
import { Tooltip } from '@material-ui/core';
import Utils from '@/common/utils/utils';
import EmailMultiChoiceInput from '../../project/EmailResponseSetting/EmailMultiChoiceInput';
import Constant from '../../../common/constant/Constant';
import { useEffect } from 'react';
import { PropTypes } from 'prop-types';

TextInputWithChip.propTypes = {
    data: PropTypes.any,
    toEmailAddressList: PropTypes.any,
    setToEmailAddressList: PropTypes.any,
    ccEmailAddressList: PropTypes.any,
    setCcEmailAddressList: PropTypes.any,
    bccEmailAddressList: PropTypes.any,
    setBccEmailAddressList: PropTypes.any,
    triggerEnableBtnSaveTicket: PropTypes.any,
    isTooltipTitle: PropTypes.any,
    label: PropTypes.any,
    isShowIconCopyFieldId: PropTypes.any,
    setIsEdited: PropTypes.any,
    listSuggestSearchEmail: PropTypes.any,
    detailTicket: PropTypes.any,
};

export default function TextInputWithChip(props) {
    let fieldData = props.data;
    let emailAddressList = [];
    let setEmailAddressList;
    let isRequiredField = false;

    switch (fieldData.sysField) {
        case Constant.SYS_FIELD.TO:
            emailAddressList = !Utils.isEmptyArray(props?.toEmailAddressList) ? props?.toEmailAddressList : [];
            setEmailAddressList = props?.setToEmailAddressList;
            isRequiredField = true;
            break;
        case Constant.SYS_FIELD.CC:
            emailAddressList = !Utils.isEmptyArray(props?.ccEmailAddressList) ? props?.ccEmailAddressList : [];
            setEmailAddressList = props?.setCcEmailAddressList;
            break;
        case Constant.SYS_FIELD.BCC:
            emailAddressList = !Utils.isEmptyArray(props?.bccEmailAddressList) ? props?.bccEmailAddressList : [];
            setEmailAddressList = props?.setBccEmailAddressList;
            break;
        default:
            break;
    }

    useEffect(() => {
        if (props?.triggerEnableBtnSaveTicket) {
            props.triggerEnableBtnSaveTicket()
        }
    }, [emailAddressList])



    return (
        <div className={'form-addTicket'}>
            <div className="cell-prod-status gap-8">
                {props?.isTooltipTitle ? (
                    <RenderTooltipTitles {...props} />
                ) : (
                    <label className="form-addTicket-label">
                        {props?.label}{' '}
                        {props.data.structure.required && <span className="required">*</span>}
                    </label>
                )}
                {props?.isShowIconCopyFieldId && (
                    <Tooltip title={props?.data.id} placement="top" arrow>
                        <img
                            src="/assets/image/icon-copy.svg"
                            alt="copy"
                            onClick={() => navigator.clipboard.writeText(props?.data.id)}
                        />
                    </Tooltip>
                )}
            </div>

            <div className="form-addTicket-input form-control-input form-control-wrapInput form-control-hg40">
                <EmailMultiChoiceInput
                    {...props}
                    addressList={emailAddressList}
                    setAddressList={setEmailAddressList}
                    setIsEdited={props?.setIsEdited}
                    listSuggestSearchEmail={!Utils.isEmptyArray(props?.listSuggestSearchEmail) ? props?.listSuggestSearchEmail : []}
                    required={isRequiredField}
                    disable={
                        props?.data?.structure?.publicForCustomer == Constant.SETTING_FORM_DEFAULT.READ_ONLY ||
                        !Utils.isEmptyString(props?.detailTicket?.deletedAt)
                    }
                />
            </div>
        </div>
    );
}
